import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getDeletedFolders, restoreFolders } from '@/api/dashboard/folders.api';
import { restoreWorkflows } from '@/api/recipes';
import { FOLDER_CONTENTS_QUERY_KEY } from './useFolders';

const ARCHIVE_QUERY_KEY = 'archive_items';

export const useGetArchiveItems = (enabled = true) =>
  useQuery({
    queryKey: [ARCHIVE_QUERY_KEY],
    queryFn: getDeletedFolders,
    enabled,
  });

export const useRestoreWorkflows = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: restoreWorkflows,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [ARCHIVE_QUERY_KEY] });
      void qc.invalidateQueries({ queryKey: [FOLDER_CONTENTS_QUERY_KEY] });
    },
  });
};

export const useRestoreFolders = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: restoreFolders,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [ARCHIVE_QUERY_KEY] });
      void qc.invalidateQueries({ queryKey: [FOLDER_CONTENTS_QUERY_KEY] });
    },
  });
};
